module.exports = __webpack_public_path__ + "static/img/icon_live.87e4ce97.svg";